import React from 'react';
import {useParams} from 'react-router-dom';
import {
    useGetCompanyAccountQuery,
    useInviteCompanyAccountMutation,
    useUpdateCompanyAccountMutation,
} from "apis/companiesApi";
import FormModal from "components/modals/FormModal";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {Checkbox} from 'primereact/checkbox';
import roles from "../../data/company-roles.json";
import {Calendar} from "primereact/calendar";
import _ from "lodash";
import {useUserProfileQuery} from "../../apis/authenticationApi";
import PhoneInput from "react-phone-number-input";

const CompanyUserModal = () => {
    const { companyuser } = useParams();
    const {data: editCompanyUser, isFetching} = useGetCompanyAccountQuery(companyuser);
    const [createCompanyAccount] = useInviteCompanyAccountMutation();
    const [updateCompanyAccount] = useUpdateCompanyAccountMutation();
    const {data: userProfile} = useUserProfileQuery();
    const editOnly = userProfile?.company?.role !== "CompanyOwner";

    const handleSubmit = (data) => {
        const clonedData = _.cloneDeep(data);

        clonedData.dateOfHire = data.dateOfHire.getTime();

        if(!clonedData.id || clonedData.id === 'new') {
            createCompanyAccount(clonedData);
        }
        else {
            updateCompanyAccount(clonedData)
        }
    }

    if(isFetching) {
        return (<></>);
    }
    else {
        const clonedTask = _.cloneDeep(editCompanyUser);

        clonedTask.dateOfHire = clonedTask.dateOfHire < 1000 ? new Date() : new Date(clonedTask.dateOfHire);

        return (<FormModal type="Company User" editObject={clonedTask || {email: ''}} handleSubmit={!editOnly? handleSubmit : undefined}
               saveAndCloseLabel={clonedTask?.id === "new" ? "Invite User" : "Save and Close"}
               renderForm={(formik) =>
                   (<form onSubmit={formik.handleSubmit} className="formgrid grid">
                       <div className="field col-12">
                            <span className="p-float-label">
                                {clonedTask?.id === "new" ? (
                                    <>
                                        <InputText id="email" name="email" className="inputfield w-full" value={formik.values?.email} onChange={formik.handleChange} autoFocus />
                                        <label htmlFor="email">Email</label>
                                    </>
                                ) : (<>
                                    <div className="col-12 flex gap-2 py-1">
                                        <span className="font-semibold col-2 read-only-label">Email:</span>
                                        <span className="read-only-field">{clonedTask?.email}</span>
                                    </div>
                                </>)}
                            </span>
                           <div className="col-12 flex gap-2 py-1">
                               <span className="font-semibold col-2 read-only-label">Activate User:</span>
                               <Checkbox id="enabled" name="enabled" onChange={formik.handleChange}  checked={formik.values?.enabled} disabled={editOnly}/>
                           </div>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="firstName" name="firstName" className="inputfield w-full" value={formik.values?.firstName} onChange={formik.handleChange} />
                                <label htmlFor="firstName">First Name</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <InputText id="lastName" name="lastName" className="inputfield w-full" value={formik.values?.lastName} onChange={formik.handleChange} />
                                <label htmlFor="lastName">Last Name</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <PhoneInput autoComplete="tel" placeholder="Phone Number" defaultCountry="US" value={formik.values?.phoneNumber} onChange={(value) => formik.setFieldValue("phoneNumber", value, false)} />
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <Dropdown name="role" value={formik.values?.role} options={roles} onChange={formik.handleChange} optionLabel="label" placeholder="Select a Role" disabled={editOnly}/>
                                <label htmlFor="role">Role</label>
                            </span>
                       </div>
                       <div className="field col-12">
                            <span className="p-float-label">
                                <Calendar className="w-4" name="dateOfHire" value={formik.values?.dateOfHire} onChange={formik.handleChange} showIcon disabled={editOnly}/>
                                <label htmlFor="dateOfHire">Date of Hire</label>
                            </span>
                       </div>
                   </form>)
               }>
        </FormModal>)
    }
}

export default CompanyUserModal;
